import {
  Box,
  Step,
  StepIcon,
  StepLabel,
  Stepper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

import { WORKSPACE_SECTIONS } from "./projectWorkspaceConfig";

const StyledStepIcon = styled(StepIcon)(({ theme }) => ({
  "&.Mui-completed": {
    color: theme.palette.success.main,
  },
}));

const LOAN_MEHRSAN_INDEX = WORKSPACE_SECTIONS.findIndex(
  (s) => s.id === "loan-mehrsan"
);
const OPERATIONAL_INDEX = WORKSPACE_SECTIONS.findIndex(
  (s) => s.id === "operational"
);

const isSectionReachable = (index, activeStepIndex, canProceedToOperational) => {
  // فقط خودِ «برنامه عملیاتی» تا قبل از تکمیل وام/مهرسان قفل است؛
  // بخش‌های بعدی (بازدید/قیمت/اجرا) اگر گردش‌کار رسیده باشد نباید دوباره قفل شوند.
  if (index === OPERATIONAL_INDEX && !canProceedToOperational) {
    return false;
  }

  if (index <= activeStepIndex) {
    return true;
  }

  if (
    index === OPERATIONAL_INDEX &&
    activeStepIndex >= LOAN_MEHRSAN_INDEX &&
    canProceedToOperational
  ) {
    return true;
  }

  return false;
};

const WorkspaceSectionNav = ({
  activeStepIndex,
  selectedSectionId,
  onSelectSection,
  canProceedToOperational = false,
}) => {
  const selectedIndex = WORKSPACE_SECTIONS.findIndex((s) => s.id === selectedSectionId);

  return (
    <Box
      sx={{
        maxHeight: { xs: "50vh", md: "calc(100vh - 280px)" },
        minHeight: 280,
        overflow: "auto",
        p: 1.5,
        "&::-webkit-scrollbar": { width: "6px" },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "grey.100",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "grey.400",
          borderRadius: "10px",
          "&:hover": { backgroundColor: "grey.500" },
        },
      }}
    >
      <Stepper activeStep={activeStepIndex} orientation="vertical" nonLinear>
        {WORKSPACE_SECTIONS.map((item, index) => {
          const reachable = isSectionReachable(
            index,
            activeStepIndex,
            canProceedToOperational
          );
          const isSelected = selectedIndex === index;

          return (
            <Step key={item.id} completed={index < activeStepIndex}>
              <StepLabel
                StepIconComponent={StyledStepIcon}
                sx={{
                  cursor: reachable ? "pointer" : "default",
                  py: 0.5,
                  px: 1,
                  mx: -1,
                  borderRadius: 1,
                  transition: "all 0.2s",
                  ...(isSelected
                    ? {
                        bgcolor: "primary.lighter",
                        ".MuiStepLabel-label": {
                          fontWeight: "700 !important",
                          color: "primary.main",
                        },
                      }
                    : {
                        "&:hover": reachable ? { bgcolor: "grey.50" } : {},
                        ...(index > activeStepIndex || !reachable
                          ? {
                              ".MuiStepLabel-label": {
                                color: "text.disabled",
                              },
                            }
                          : {}),
                      }),
                }}
                onClick={() => reachable && onSelectSection(item.id)}
              >
                {item.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

WorkspaceSectionNav.propTypes = {
  activeStepIndex: PropTypes.number.isRequired,
  selectedSectionId: PropTypes.string.isRequired,
  onSelectSection: PropTypes.func.isRequired,
  canProceedToOperational: PropTypes.bool,
};

export default WorkspaceSectionNav;
